module.exports = __webpack_public_path__ + "static/img/no-select-chat.e55cbf6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/no-select-chat.svg
// module id = RRi/
// module chunks = 31